var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.33 3.545A7.47 7.47 0 0 1 10.22.838c3.973 1.061 6.34 5.127 5.276 9.086-1.065 3.958-5.152 6.298-9.124 5.238a7.44 7.44 0 0 1-5.447-6.06.75.75 0 0 1 1.484-.226 5.94 5.94 0 0 0 4.35 4.836c3.18.85 6.441-1.026 7.288-4.177s-1.034-6.399-4.213-7.248a5.97 5.97 0 0 0-6.177 1.998l1.438-.489a.75.75 0 0 1 .484 1.42L2.225 6.36a.75.75 0 0 1-.977-.565L.56 2.32l-.012-.076a.75.75 0 0 1 1.464-.29l.019.075zm5.254.82a.75.75 0 0 1 1.5 0v3.32l1.366 1.35.052.057a.75.75 0 0 1-1.05 1.062l-.057-.051-1.588-1.57A.75.75 0 0 1 7.584 8z"
  })));
};
export default Svg16;